module.exports = __webpack_public_path__ + "img/backup-24px.d4183698.svg";